import 'core-js';
import Vue from 'vue';
import { Http } from '@pirates/not-morty-biz';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './localization/i18n';
import { SpaUtils } from '@/utils/plugins';
import './directives/fetch-user';
import { createUUID, interceptors, TokenService } from '@/utils/auth';
import '@/utils/ie.polyfill';

import './assets/fonts/icons.css';

Vue.config.productionTip = false;
Vue.use(SpaUtils);

const initVue = () => {
  new Vue({
    router,
    store,
    i18n,
    data: {
      loading: true,
    },
    render: (h) => h(App),
  }).$mount('#app');
};

const tokenService = new TokenService(false, store);
Http.addInterceptor('request', 'success', (config) => {
  // set a unique id for each request to differentiate between them on retry
  config.headers['X-REQUEST-ID'] = createUUID();
  return config;
})
  .addInterceptor('request', 'success', interceptors.authTokenInjector(tokenService))
  .addInterceptor('response', 'error', interceptors.refreshTokenAndRetry(tokenService))
  .addInterceptor(
    'response',
    'error',
    interceptors.handleServerError((error) => {
      // TODO: report to sentry
      store.dispatch('app/showServerError', error);
    }),
  )
  .addInterceptor('response', 'success', interceptors.clearSuccessfulRequest(tokenService));

const main = async () => {
  require('@/utils/sentry');
  await initVue();
};

// tslint:disable-next-line:no-floating-promises
main();
